export const SET_ORGANIZATION = 'SET_ORGANIZATION'
export const SET_AVALIABLE_ORGANIZATIONS = 'SET_AVALIABLE_ORGANIZATIONS'

export function setOrganization (org) {
  console.log('set organization', org)
  return dispatch => {
    dispatch({
      type: SET_ORGANIZATION,
      data: org
    })
  }
}

export function setAvaliableOrganizations (list) {
  return dispatch => {
    dispatch({
      type: SET_AVALIABLE_ORGANIZATIONS,
      data: list
    })
  }
}
